export default __webpack_public_path__ + "static/media/down.cb9e17b9.svg";